import React from "react";
import { withTheme } from "../../../theming";

const Footer = ({ theme }) => {
  return (
    <footer
      style={{
        backgroundColor: theme.accentColor || "#00796b",
        color: theme.buttonTextColor || "#FFF",
      }}
      className="p-8 mt-auto"
    >
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ color: theme.secondaryColor || "#4db6ac" }}
            >
              Fipsr Agentics
            </h4>
            <p className="text-sm">
              Enterprise-grade AI workflow automation for startups. Affordable
              pricing, enterprise-scale results.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ color: theme.secondaryColor || "#4db6ac" }}
            >
              Services
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:opacity-80">
                  Agent Designer Canvas
                </a>
              </li>
              <li>
                <a href="#" className="hover:opacity-80">
                  AWS Serverless Scaling
                </a>
              </li>
              <li>
                <a href="#" className="hover:opacity-80">
                  Custom AI Agents
                </a>
              </li>
              <li>
                <a href="#" className="hover:opacity-80">
                  Integration Solutions
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ color: theme.secondaryColor || "#4db6ac" }}
            >
              Contact
            </h4>
            <p className="text-sm mb-2">Ready to start your transformation?</p>
            <p className="text-sm mb-2">
              <a href="#" className="hover:opacity-80">
                Schedule Free Consultation
              </a>
            </p>
            <p className="text-sm">
              <a href="#" className="hover:opacity-80">
                hello@fipseragentics.com
              </a>
            </p>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 text-center text-sm">
          <p>
            &copy; 2025 Fipsr Agentics. Your consultation starts the
            conversation. Your agents start the transformation.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default withTheme(Footer);
